import TeamBuilder from "@/Components/TeamBuilder/team_builder_core/TeamBuilder";
import { Card } from "@/Components/ui/card";
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";
import { useIsMobile } from "@/hooks/use-mobile";
import WizardProvider from "@/Components/wizard/wizardProvider";
import { getBasicPageTourSteps } from "@/Components/TeamBuilder/wizards/basic_page_tour";

const Team = () => {
  const zoomLevel = useResponsiveZoom();
  const isMobile = useIsMobile();

  return (
    <Card className="p-2 m-2" style={{ zoom: zoomLevel }}>
      <WizardProvider wizardSteps={getBasicPageTourSteps()} >
        <div id="title-container" className="flex flex-row">
          <div className={`${isMobile ? "text-4xl" : "text-2xl"} font-bold ml-2`}>Team</div>
        </div>
        <div className={`${isMobile ? "text-lg" : "text-sm"} text-gray-500 ml-2`}>Manage your team members</div>
        <TeamBuilder showHelpLink={true} />
      </WizardProvider>
    </Card>
  );
}

export default Team